module.exports = __webpack_public_path__ + "static/media/CW.60694e9f.gif";